import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Table,
  Card,
  Badge,
  Modal,
  Row,
  Col,
  Alert,
  ProgressBar,
   Dropdown
} from "react-bootstrap";
import {
  FaPlus,
  FaEdit,
  FaCheck,
  FaExclamationCircle,
  FaClock
} from "react-icons/fa";
import '../../ComponentsCss/GrievanceManagementTab.css'
import { useAuth } from "../../contexts/AuthContext";

const GrievanceManagementTab = ({ userData, showNotification,logToAccessLogs }) => {
  const [grievances, setGrievances] = useState([]);
  const [showGrievanceModal, setShowGrievanceModal] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [responseText, setResponseText] = useState("");
  const { profile } = useAuth();
     const organizationId = profile?.orgId;

  const [grievanceForm, setGrievanceForm] = useState({
    complainantName: "",
    complainantEmail: "",
    grievanceType: "",
    description: "",
    priority: "medium",
    affectedDataCategory: "",
     evidenceFiles: []
  });

  

  const [grievanceStats, setGrievanceStats] = useState({
    total: 0,
    pending: 0,
    resolved: 0,
    escalated: 0
  });
const [showOfficerModal, setShowOfficerModal] = useState(false);
const [grievanceOfficer, setGrievanceOfficer] = useState({
  name: "",
  email: "",
  phone: "",
  department: ""
});
  const getUserRegion = () => {
    return sessionStorage.getItem("userRegion") || "IN";
  };

  useEffect(() => {
    fetchGrievances();
  }, [userData]);

  const fetchGrievances = async () => {
    const userId = organizationId;
    const region = getUserRegion();

    try {
      const res = await fetch(
        "https://85sm4need1.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/list",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Region: region,
            organizationId: organizationId
          }
        }
      );
      const data = await res.json();
      setGrievances(data.grievances || []);
      setGrievanceStats(data.stats || grievanceStats);
    } catch (err) {
      console.error("Error fetching grievances", err);
      // showNotification("Failed to load grievances", "danger");
    }
  };


  const fetchGrievanceOfficer = async () => {
  const userId = organizationId;
  const region = getUserRegion();

  try {
    const res = await fetch(
      "https://1n35t55f8d.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/officer",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Region: region,
          organizationId: organizationId
        }
      }
    );
    if (res.ok) {
      const data = await res.json();
      setGrievanceOfficer(data.officer || grievanceOfficer);
    }
  } catch (err) {
    console.error("Error fetching grievance officer", err);
  }
};

// Save grievance officer details
const handleSaveOfficer = async (e) => {
  e.preventDefault();
  const userId = organizationId;
  const region = getUserRegion();

  try {
    const res = await fetch(
      "https://lozabok3s1.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/officer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Region: region,
        organizationId: organizationId
        },
        body: JSON.stringify(grievanceOfficer)
      }
    );

    if (res.ok) {
      showNotification("Grievance Officer details saved successfully", "success");
      setShowOfficerModal(false);
      fetchGrievanceOfficer();
    } else {
      showNotification("Failed to save grievance officer details", "danger");
    }
  } catch (err) {
    console.error("Error saving grievance officer", err);
    showNotification("Error saving grievance officer details", "danger");
  }
};

// Update useEffect to fetch officer details
useEffect(() => {
  fetchGrievances();
  fetchGrievanceOfficer();
}, [userData]);
const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  
  // Validate file size (e.g., max 5MB per file)
  const validFiles = selectedFiles.filter(file => {
    if (file.size > 10 * 1024 * 1024) {
      showNotification(`${file.name} exceeds 10MB limit`, "warning");
      return false;
    }
    return true;
  });
  
  setGrievanceForm({
    ...grievanceForm,
    evidenceFiles: validFiles
  });
};

const handleDeleteGrievance = async (grievanceId) => {
  if (!window.confirm("Are you sure you want to delete this grievance and all its evidence files? This action cannot be undone.")) {
    return;
  }

  const userId = organizationId;
  const region = getUserRegion();

  try {
    const res = await fetch(
      `https://qc5v7luez7.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/delete/${grievanceId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Region: region,
         organizationId: organizationId
        }
      }
    );

    if (res.ok) {
      const data = await res.json();
      showNotification(
        `Grievance deleted successfully. ${data.evidenceFilesDeleted} evidence file(s) removed.`, 
        "success"
      );
      logToAccessLogs?.({
  action:      'Grievance Deleted',
  severity:    'critical',
  description: `Grievance ${grievanceId} deleted`,});
      fetchGrievances(); // Refresh the list
    } else {
      showNotification("Failed to delete grievance", "danger");
    }
  } catch (err) {
    console.error("Error deleting grievance", err);
    showNotification("Error deleting grievance", "danger");
  }
};


const handleSubmitGrievance = async (e) => {
  e.preventDefault();
  const userId = organizationId;
  const region = getUserRegion();

  try {
    const formData = new FormData();
    
    // Append text fields
    formData.append("complainantName", grievanceForm.complainantName);
    formData.append("complainantEmail", grievanceForm.complainantEmail);
    formData.append("grievanceType", grievanceForm.grievanceType);
    formData.append("description", grievanceForm.description);
    formData.append("priority", grievanceForm.priority);
    formData.append("affectedDataCategory", grievanceForm.affectedDataCategory);
    formData.append("status", "pending");
    formData.append("submittedDate", new Date().toISOString());
    formData.append("dueDate", calculateDueDate(grievanceForm.grievanceType));
    
    // Append files
     if (grievanceForm.evidenceFiles && grievanceForm.evidenceFiles.length > 0) {
      grievanceForm.evidenceFiles.forEach((file, index) => {
        formData.append("evidenceFiles", file);
      });
    }

    const res = await fetch(
      "https://9byd0lusdi.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/create",
      {
        method: "POST",
        headers: {
          Region: region,
          organizationId: organizationId
          // Don't set Content-Type - browser will set it with boundary for multipart
        },
        body: formData
      }
    );

    if (res.ok) {
      showNotification("Grievance submitted successfully", "success");
      logToAccessLogs?.({
  action:      'Grievance Submitted',
  severity:    grievanceForm.priority === 'high' ? 'critical' : 'warning',
  description: `Grievance submitted by ${grievanceForm.complainantEmail} â€” Type: ${grievanceForm.grievanceType}`,});
      setShowGrievanceModal(false);
      fetchGrievances();
      resetForm();
    } else {
      showNotification("Failed to submit grievance", "danger");
    }
  } catch (err) {
    console.error("Error submitting grievance", err);
    showNotification("Error submitting grievance", "danger");
  }
};

const handleDownload = async (url, fileName) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error("Download failed", err);
    showNotification("Failed to download file", "danger");
  }
};


const calculateDueDate = (grievanceType) => {
  const now = new Date();
  let daysToAdd = 90; // default for Request lifecycle
  
  switch (grievanceType) {
    case "Board registration & reporting":
      // Immediate deadline
      daysToAdd = 0;
      break;
      
    case "Consent Manager integration":
      // By Nov 2026 - calculate days until that date
      const nov2026 = new Date('2026-11-13');
      return nov2026.toISOString();
      
    case "Data Correction Request":
    case "Data Deletion Request":
    case "Unauthorized Data Access":
    case "Consent Violation":
      // Request lifecycle: â‰¤ 90 days to fulfill DP principal rights
      daysToAdd = 90;
      break;
      
    case "Data Breach":
      // Breach Incident SLA: â‰¤ 72 hours to notify Board
      const hoursToAdd = 72;
      now.setHours(now.getHours() + hoursToAdd);
      return now.toISOString();
      
    case "Security Safeguard audits":
      // Within 18 months
      daysToAdd = 548; // approximately 18 months
      break;
      
    case "Retention enforcement":
      // 0-X days based on retention policy - use 30 as default
      daysToAdd = 30;
      break;
      
    case "DPO reporting":
      // Monthly/quarterly - use 30 days as default
      daysToAdd = 30;
      break;
      
    default:
      // Default 30 days for other grievance types
      daysToAdd = 30;
  }
  
  now.setDate(now.getDate() + daysToAdd);
  return now.toISOString();
};


  const handleResolveGrievance = async (grievanceId) => {
    const userId = organizationId;
    const region = getUserRegion();

    try {
      const res = await fetch(
        `https://jsga2ivd20.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/resolve/${grievanceId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Region: region,
            organizationId: organizationId
          },
          body: JSON.stringify({
            response: responseText,
            resolvedDate: new Date().toISOString()
          })
        }
      );

      if (res.ok) {
        showNotification("Grievance resolved successfully", "success");
        logToAccessLogs?.({
  action:      'Grievance Resolved',
  severity:    'success',
  description: `Grievance ${grievanceId} resolved`,});
        setShowResponseModal(false);
        fetchGrievances();
      }
    } catch (err) {
      console.error("Error resolving grievance", err);
    }
  };

  const handleEscalate = async (grievanceId) => {
    const userId =organizationId;
    const region = getUserRegion();

    try {
      const res = await fetch(
        `https://vyy069vkaf.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/grievances/escalate/${grievanceId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Region: region,
            organizationId: organizationId
          }
        }
      );

      if (res.ok) {
        // showNotification("Grievance escalated to Data Protection Board", "warning");
        fetchGrievances();
        logToAccessLogs?.({
  action:      'Grievance Escalated',
  severity:    'critical',
  description: `Grievance ${grievanceId} escalated to Data Protection Board`,});
      }
    } catch (err) {
      console.error("Error escalating grievance", err);
    }
  };

  const resetForm = () => {
    setGrievanceForm({
      complainantName: "",
      complainantEmail: "",
      grievanceType: "",
      description: "",
      priority: "medium",
      affectedDataCategory: "",
      evidenceFiles: []
    });
  };

  const getStatusBadge = (status) => {
    const variants = {
      pending: "warning",
      "in-progress": "info",
      resolved: "success",
      escalated: "danger"
    };
    return <Badge bg={variants[status]}>{status.toUpperCase()}</Badge>;
  };

  const getDaysRemaining = (dueDate) => {
    const days = Math.floor((new Date(dueDate) - new Date()) / (1000 * 60 * 60 * 24));
    return days;
  };

  return (
    <div className="grievance-management-tab">
      {/* Statistics */}
      <Row className="mb-4">
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <h3>{grievanceStats.total}</h3>
              <p>Total Grievances</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center border-warning">
            <Card.Body>
              <h3 className="text-warning">{grievanceStats.pending}</h3>
              <p>Open</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center border-success">
            <Card.Body>
              <h3 className="text-success">{grievanceStats.resolved}</h3>
              <p>Resolved</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center border-danger">
            <Card.Body>
              <h3 className="text-danger">{grievanceStats.escalated}</h3>
              <p>Escalated to DPB</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* Grievance Officer Information */}
<Card className="mb-3">
  <Card.Header className="d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Grievance Officer Details</h5>
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => setShowOfficerModal(true)}
    >
      <FaEdit /> Edit
    </Button>
  </Card.Header>
  <Card.Body>
    {grievanceOfficer.name ? (
      <Row>
        <Col md={3}>
          <p className="mb-1"><strong>Name:</strong></p>
          <p>{grievanceOfficer.name}</p>
        </Col>
        <Col md={3}>
          <p className="mb-1"><strong>Email:</strong></p>
          <p>{grievanceOfficer.email}</p>
        </Col>
        <Col md={3}>
          <p className="mb-1"><strong>Phone:</strong></p>
          <p>{grievanceOfficer.phone || "N/A"}</p>
        </Col>
        <Col md={3}>
          <p className="mb-1"><strong>Department:</strong></p>
          <p>{grievanceOfficer.department || "N/A"}</p>
        </Col>
      </Row>
    ) : (
      <Alert variant="warning">
        <FaExclamationCircle /> No Grievance Officer configured. Please add officer details to receive notifications.
      </Alert>
    )}
  </Card.Body>
</Card>


      {/* Action Bar */}
      <Card className="mb-3">
        <Card.Body>
          <Button
            variant="primary"
            onClick={() => setShowGrievanceModal(true)}
          >
            <FaPlus /> Submit New Grievance
          </Button>
        </Card.Body>
      </Card>

      {/* Grievances Table */}
      <Card>
        <Card.Header>
          <h5>Grievance Records</h5>
        </Card.Header>
        <Card.Body>
          <Table responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Complainant</th>
                <th>Type</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Submitted</th>
                <th>Due In</th>
                 <th>Evidence</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {grievances.length > 0 ? (
                grievances.map((grievance) => {
                  const daysLeft = getDaysRemaining(grievance.dueDate);
                  return (
                    <tr key={grievance.grievanceId}>
                      <td>{grievance.grievanceId}</td>
                      <td>{grievance.complainantName}</td>
                      <td>{grievance.grievanceType}</td>
                      <td>
                        <Badge
                          bg={
                            grievance.priority === "high"
                              ? "danger"
                              : grievance.priority === "medium"
                              ? "warning"
                              : "info"
                          }
                        >
                          {grievance.priority}
                        </Badge>
                      </td>
                      <td>{getStatusBadge(grievance.status)}</td>
                      <td>
                        {new Date(grievance.submittedDate).toLocaleDateString()}
                      </td>
                      
                      <td>
                        <span className={daysLeft <= 5 ? "text-danger" : ""}>
                          {daysLeft > 0 ? `${daysLeft} days` : "Overdue"}
                        </span>
                      </td>
                     <td style={{ minWidth: '200px' }}>
  {grievance.evidenceUrls && grievance.evidenceUrls.length > 0 ? (
    <div className="d-flex flex-column gap-1">
      {grievance.evidenceUrls.map((url, idx) => {
        // Extract filename from URL and shorten if too long
        const fullFileName = url.split('/').pop().split('?')[0]; // Remove query params
        const fileName = fullFileName.length > 20 
          ? fullFileName.substring(0, 17) + '...' 
          : fullFileName;
        
        return (
          <div key={idx} className="d-flex align-items-center gap-1">
            <Button
              variant="link"
              size="sm"
              onClick={() => window.open(url, '_blank')}
              className="p-0 text-decoration-none text-truncate"
              style={{ maxWidth: '120px' }}
              title={fullFileName}
            >
              ðŸ“Ž {fileName}
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => handleDownload(url, fullFileName)}
              style={{ fontSize: '0.75rem', padding: '0.15rem 0.4rem' }}
            >
              â¬‡
            </Button>
          </div>
        );
      })}
    </div>
  ) : (
    <span className="text-muted" style={{ fontSize: '0.85rem' }}>
      No attachments
    </span>
  )}
</td>


                   <td>
  <Dropdown>
    <Dropdown.Toggle 
      variant="outline-secondary" 
      size="sm" 
      id={`dropdown-${grievance.grievanceId}`}
    >
      Actions
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item
        onClick={() => {
          setSelectedGrievance(grievance);
          setShowResponseModal(true);
        }}
        disabled={grievance.status === "resolved"}
      >
        <FaCheck className="me-2" />
        Resolve
      </Dropdown.Item>
      
      <Dropdown.Item
        onClick={() => handleEscalate(grievance.grievanceId)}
        disabled={grievance.status === "escalated"}
      >
        <FaExclamationCircle className="me-2" />
        Escalate
      </Dropdown.Item>
      
      <Dropdown.Divider />
      
      <Dropdown.Item
        onClick={() => handleDeleteGrievance(grievance.grievanceId)}
        className="text-danger"
      >
        Delete
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
</td>


                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No grievances found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Submit Grievance Modal */}
      <Modal
        show={showGrievanceModal}
        onHide={() => setShowGrievanceModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit New Grievance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitGrievance}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Complainant Name</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    value={grievanceForm.complainantName}
                    onChange={(e) =>
                      setGrievanceForm({
                        ...grievanceForm,
                        complainantName: e.target.value
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    value={grievanceForm.complainantEmail}
                    onChange={(e) =>
                      setGrievanceForm({
                        ...grievanceForm,
                        complainantEmail: e.target.value
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Grievance Type</Form.Label>
                  <Form.Select
  required
  value={grievanceForm.grievanceType}
  onChange={(e) =>
    setGrievanceForm({
      ...grievanceForm,
      grievanceType: e.target.value
    })
  }
>
  <option value="">Select...</option>
  <option value="Board registration & reporting">Board registration & reporting</option>
  <option value="Consent Manager integration">Consent Manager integration</option>
  <option value="Data Correction Request">Data Correction Request</option>
  <option value="Data Deletion Request">Data Deletion Request</option>
  <option value="Unauthorized Data Access">Unauthorized Data Access</option>
  <option value="Consent Violation">Consent Violation</option>
  <option value="Data Breach">Data Breach/Incident (â‰¤72 hours)</option>
  <option value="Security Safeguard audits">Security Safeguard audits</option>
  <option value="Retention enforcement">Retention enforcement</option>
  <option value="DPO reporting">DPO reporting</option>
  <option value="Other">Other</option>
</Form.Select>

                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Priority</Form.Label>
                  <Form.Select
                    required
                    value={grievanceForm.priority}
                    onChange={(e) =>
                      setGrievanceForm({
                        ...grievanceForm,
                        priority: e.target.value
                      })
                    }
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Affected Data Category</Form.Label>
              <Form.Control
                type="text"
                required
                value={grievanceForm.affectedDataCategory}
                onChange={(e) =>
                  setGrievanceForm({
                    ...grievanceForm,
                    affectedDataCategory: e.target.value
                  })
                }
                placeholder="E.g., Personal contact information"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                required
                value={grievanceForm.description}
                onChange={(e) =>
                  setGrievanceForm({
                        ...grievanceForm,
                    description: e.target.value
                  })
                }
                placeholder="Provide detailed description of your grievance"
              />
            </Form.Group>
            <Form.Group className="mb-3">
  <Form.Label>Evidence Attachments (Optional)</Form.Label>
  <Form.Control
    type="file"
    multiple
    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
    onChange={handleFileChange}
  />
  <Form.Text className="text-muted">
    Max 10MB per file. Accepted formats: PDF, JPG, PNG, DOC, DOCX
  </Form.Text>
  
  {/* Display selected files */}
  {grievanceForm.evidenceFiles.length > 0 && (
    <div className="selected-files-griv">
      <strong>Selected Files:</strong>
      <ul>
        {grievanceForm.evidenceFiles.map((file, index) => (
          <li key={index}>
            {file.name} ({(file.size / 1024).toFixed(2)} KB)
          </li>
        ))}
      </ul>
    </div>
  )}
</Form.Group>
    
            <Alert variant="info">
              <FaExclamationCircle /> Your grievance will be processed within 30
              days as per DPDP Act 2023. You will receive updates via email.
            </Alert>

            <Button variant="primary" type="submit">
              Submit Grievance
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Response Modal */}
      <Modal
        show={showResponseModal}
        onHide={() => setShowResponseModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Resolve Grievance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGrievance && (
            <>
              <p>
                <strong>Grievance ID:</strong> {selectedGrievance.grievanceId}
              </p>
              <p>
                <strong>Type:</strong> {selectedGrievance.grievanceType}
              </p>
              <p>
                <strong>Description:</strong> {selectedGrievance.description}
              </p>
              <Form.Group className="mb-3">
                <Form.Label>Resolution Response</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={responseText}
                  onChange={(e) => setResponseText(e.target.value)}
                  placeholder="Enter resolution details and actions taken"
                />
              </Form.Group>
              <Button
                variant="success"
                onClick={() =>
                  handleResolveGrievance(selectedGrievance.grievanceId)
                }
              >
                <FaCheck /> Mark as Resolved
              </Button>
            </>
          )}
        </Modal.Body>
      </Modal>
      {/* Grievance Officer Modal */}
<Modal
  show={showOfficerModal}
  onHide={() => setShowOfficerModal(false)}
  size="md"
>
  <Modal.Header closeButton>
    <Modal.Title>Grievance Officer Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleSaveOfficer}>
      <Form.Group className="mb-3">
        <Form.Label>Officer Name *</Form.Label>
        <Form.Control
          type="text"
          required
          value={grievanceOfficer.name}
          onChange={(e) =>
            setGrievanceOfficer({
              ...grievanceOfficer,
              name: e.target.value
            })
          }
          placeholder="Enter officer name"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Email Address *</Form.Label>
        <Form.Control
          type="email"
          required
          value={grievanceOfficer.email}
          onChange={(e) =>
            setGrievanceOfficer({
              ...grievanceOfficer,
              email: e.target.value
            })
          }
          placeholder="officer@company.com"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          type="tel"
          value={grievanceOfficer.phone}
          onChange={(e) =>
            setGrievanceOfficer({
              ...grievanceOfficer,
              phone: e.target.value
            })
          }
          placeholder="+91 XXXXXXXXXX"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Department</Form.Label>
        <Form.Control
          type="text"
          value={grievanceOfficer.department}
          onChange={(e) =>
            setGrievanceOfficer({
              ...grievanceOfficer,
              department: e.target.value
            })
          }
          placeholder="e.g., Legal & Compliance"
        />
      </Form.Group>

      <Alert variant="info" className="mb-3">
        <small>
          <FaExclamationCircle /> The grievance officer will receive email notifications for all new grievances submitted.
        </small>
      </Alert>

      <div className="d-flex gap-2">
        <Button variant="primary" type="submit">
          Save Officer Details
        </Button>
        <Button 
          variant="secondary" 
          onClick={() => setShowOfficerModal(false)}
        >
          Cancel
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

    </div>
  );
};

export default GrievanceManagementTab;